import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  "data-testid": "step-PersonalData",
  class: "container"
}
const _hoisted_2 = { class: "container__personal-data-header" }
const _hoisted_3 = {
  key: 0,
  class: "container__personal-data-p t-bold t-center",
  "cy-data": "uploadMessage"
}
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = {
  key: 1,
  class: "personal-data-layer"
}
const _hoisted_6 = { class: "personal-data-layer__row" }
const _hoisted_7 = { class: "personal-data-layer__row" }
const _hoisted_8 = { class: "personal-data-layer__row" }
const _hoisted_9 = { class: "personal-data-layer__row" }
const _hoisted_10 = { class: "personal-data-layer__row" }
const _hoisted_11 = { class: "personal-data-layer__row" }
const _hoisted_12 = { class: "personal-data-layer__row buttons-row" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "row row--date-of-birth" }
const _hoisted_16 = { class: "row custom-select-wrapper" }
const _hoisted_17 = {
  key: 0,
  class: "row"
}
const _hoisted_18 = { class: "new-account__prohibited-warning" }
const _hoisted_19 = { class: "row custom-select-wrapper" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = {
  key: 1,
  class: "row row--document-expiry-date"
}
const _hoisted_22 = {
  key: 2,
  class: "row row--is-never-expiration-document"
}
const _hoisted_23 = {
  key: 3,
  class: "row"
}
const _hoisted_24 = {
  key: 0,
  class: "personal-id-number-description"
}
const _hoisted_25 = { class: "row custom-select-wrapper" }
const _hoisted_26 = {
  key: 4,
  class: "row"
}
const _hoisted_27 = { class: "new-account__prohibited-warning" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_SubmitButton = _resolveComponent("SubmitButton")!
  const _component_Field = _resolveComponent("Field")!
  const _component_DateField = _resolveComponent("DateField")!
  const _component_TheCountrySelect = _resolveComponent("TheCountrySelect")!
  const _component_Select = _resolveComponent("Select")!
  const _component_CheckBox = _resolveComponent("CheckBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.personalDataHeader`)), 1),
    (_ctx.isSubheaderVisible)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.personalDataCheckData`)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      ref: "personalDataFormRef",
      class: _normalizeClass([_ctx.isOpenPersonalDataLayer ? 'modify-form' : '']),
      onSubmit: _withModifiers(($event: any) => (null), ["prevent"])
    }, [
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            (_ctx.isAnimating)
              ? (_openBlock(), _createBlock(_component_Loader, {
                  key: 0,
                  class: _normalizeClass([
                            'loader--position-absolute',
                            'loader--background-white',
                            'loader--clear-transform',
                            _ctx.isAnimating ? 'active' : '',
                        ])
                }, null, 8, ["class"]))
              : _createCommentVNode("", true),
            (_ctx.isOpenPersonalDataLayer)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.forename`)), 1),
                    _createElementVNode("div", null, _toDisplayString(_ctx.formData.firstName.length
                                        ? _ctx.formData.firstName
                                        : _ctx.$t(`${_ctx.TRANSLATION_KEY}.noData`)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.surname`)), 1),
                    _createElementVNode("div", null, _toDisplayString(_ctx.formData.lastName.length
                                        ? _ctx.formData.lastName
                                        : _ctx.$t(`${_ctx.TRANSLATION_KEY}.noData`)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.birthDate`)), 1),
                    _createElementVNode("div", null, _toDisplayString(_ctx.formData.dateOfBirth.length
                                        ? _ctx.formData.dateOfBirth
                                        : _ctx.$t(`${_ctx.TRANSLATION_KEY}.noData`)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.formData.citizenship === 'PL' ||
                                    (null != _ctx.formData.citizenship &&
                                        !_ctx.formData.citizenship.length)
                                        ? _ctx.$t(
                                              `${_ctx.TRANSLATION_KEY}.personalIdNumber`
                                          )
                                        : _ctx.$t(
                                              `${_ctx.TRANSLATION_KEY}.secondPersonalIdNumber`
                                          )), 1),
                    _createElementVNode("div", null, _toDisplayString(_ctx.determineGenuineValue([
                                        _ctx.formData.identificationNumber,
                                        _ctx.formData.pesel,
                                    ])), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.idNumber`)), 1),
                    _createElementVNode("div", null, _toDisplayString(_ctx.formData.documentNumber.length
                                        ? _ctx.formData.documentNumber
                                        : _ctx.$t(`${_ctx.TRANSLATION_KEY}.noData`)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.documentExpiryDate`)), 1),
                    _createElementVNode("div", null, _toDisplayString(_ctx.formData.documentExpirationDate.length
                                        ? _ctx.formData.documentExpirationDate
                                        : _ctx.$t(`${_ctx.TRANSLATION_KEY}.noData`)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "button",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpenPersonalDataLayer = false))
                    }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.correct`)), 1),
                    _createVNode(_component_SubmitButton, {
                      action: _ctx.Action.PERSONAL_DATA_CONFIRM,
                      "button-value": _ctx.$t(`${_ctx.TRANSLATION_KEY}.confirm`),
                      data: _ctx.formData,
                      class: "button button--submit button--green"
                    }, null, 8, ["action", "button-value", "data"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_Field, {
          ref: "firstNameField",
          modelValue: _ctx.formData.firstName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.firstName = $event)),
          type: "text",
          name: "firstName",
          "cy-data": "name",
          placeholder: _ctx.$t(`${_ctx.TRANSLATION_KEY}.forenamePlaceholder`)
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.forename`)), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_Field, {
          ref: "lastNameField",
          modelValue: _ctx.formData.lastName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.lastName = $event)),
          type: "text",
          name: "lastName",
          "cy-data": "surname",
          placeholder: _ctx.$t(`${_ctx.TRANSLATION_KEY}.surnamePlaceholder`)
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.surname`)), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_DateField, {
          modelValue: _ctx.formData.dateOfBirth,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.dateOfBirth = $event)),
          name: "dateOfBirth",
          "cy-data": "date-of-birth",
          label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.birthDate`),
          onBlur: _ctx.validateDateOfBirth
        }, null, 8, ["modelValue", "label", "onBlur"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_TheCountrySelect, {
          name: "citizenship",
          "default-value": _ctx.formData.citizenship,
          "country-list": _ctx.citizenship,
          label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.citizenshipLabel`),
          placeholder: 
                        _ctx.$t(`${_ctx.TRANSLATION_KEY}.citizenshipPlaceholder`)
                    ,
          class: "custom-select",
          onSelectedCountry: _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.citizenship = $event))
        }, null, 8, ["default-value", "country-list", "label", "placeholder"])
      ]),
      (_ctx.isProhibitedCitizenship)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.prohibitedCountryInfo`)), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_Select, {
          modelValue: _ctx.formData.documentType,
          "onUpdate:modelValue": [
            _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.documentType = $event)),
            _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.documentType = $event))
          ],
          name: "documentType",
          "item-list": _ctx.documentTypes,
          label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.documentTypeOne`),
          placeholder: _ctx.$t(`${_ctx.TRANSLATION_KEY}.documentTypeOne`),
          "cy-data": "document-type"
        }, null, 8, ["modelValue", "item-list", "label", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_Field, {
          ref: "documentNumberField",
          modelValue: _ctx.formData.documentNumber,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.documentNumber = $event)),
          type: "text",
          name: "documentNumber",
          placeholder: _ctx.$t(`${_ctx.TRANSLATION_KEY}.idNumberPlaceholder`),
          "cy-data": "document-number",
          "no-auto-validation": true,
          onBlur: _ctx.handleValidateDocumentField
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.idNumber`)), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "onBlur"])
      ]),
      (!_ctx.formData.noLimitExpiryDate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createVNode(_component_DateField, {
              modelValue: _ctx.formData.documentExpirationDate,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.documentExpirationDate = $event)),
              "cy-data": "date-of-expiration",
              name: _ctx.DateFieldNames.EXPIRATION,
              label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.documentExpiryDate`),
              onBlur: _ctx.validateDateOfExpiration
            }, null, 8, ["modelValue", "name", "label", "onBlur"])
          ]))
        : _createCommentVNode("", true),
      (
                    _ctx.formData.documentType !== '2' &&
                    _ctx.formData.citizenship !== 'DE'
                )
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createVNode(_component_CheckBox, {
              modelValue: _ctx.formData.noLimitExpiryDate,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.noLimitExpiryDate = $event)),
              name: "noLimitExpiryDate",
              value: false,
              "cy-data": "no-expiry-date"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.expirationDocumentText`)), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.shouldShowIdentificationNumberField())
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            (_ctx.getPersonalIdNumberDescription())
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.personalIdNumberDescription), 1))
              : _createCommentVNode("", true),
            (
                        (_ctx.UtilityHelper.getLocale() === _ctx.Locale.PL &&
                            null !== _ctx.formData.citizenship &&
                            !_ctx.formData.citizenship.length) ||
                        (null !== _ctx.formData.citizenship &&
                            _ctx.formData.citizenship.toLowerCase() === _ctx.Locale.PL)
                    )
              ? (_openBlock(), _createBlock(_component_Field, {
                  key: "pesel",
                  ref: "peselField",
                  modelValue: _ctx.formData.pesel,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formData.pesel = $event)),
                  type: "text",
                  name: "pesel",
                  "max-length": 11,
                  placeholder: _ctx.$t(`${_ctx.TRANSLATION_KEY}.number`),
                  "cy-data": "pesel",
                  "is-numeric": true
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.number`)), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"]))
              : (_openBlock(), _createBlock(_component_Field, {
                  key: "identificationNumber",
                  ref: "identificationNumberField",
                  modelValue: _ctx.formData.identificationNumber,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formData.identificationNumber = $event)),
                  type: "text",
                  name: "identificationNumber",
                  placeholder: _ctx.$t(`${_ctx.TRANSLATION_KEY}.number`),
                  "is-validated": _ctx.isValidateIdentificationField,
                  "cy-data": "tin",
                  "is-numeric": _ctx.numericalID ? true : false
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.number`)), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "is-validated", "is-numeric"]))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_TheCountrySelect, {
          name: "birthPlaceCountry",
          "default-value": _ctx.defaultBirthPlaceCountry,
          "country-list": _ctx.birthPlaceCountries,
          label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.birthPlaceCountry`),
          placeholder: _ctx.$t(`${_ctx.TRANSLATION_KEY}.birthPlaceCountry`),
          class: "custom-select",
          onSelectedCountry: _cache[12] || (_cache[12] = ($event: any) => (_ctx.formData.birthPlaceCountry = $event))
        }, null, 8, ["default-value", "country-list", "label", "placeholder"])
      ]),
      (_ctx.isProhibitedBirthPlaceCountry)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.prohibitedCountryInfo`)), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_SubmitButton, {
        action: _ctx.Action.PERSONAL_DATA_CONFIRM,
        "button-value": _ctx.$t(`${_ctx.TRANSLATION_KEY}.next`),
        "data-testid": "btn-riskAssessment-nextStep",
        data: _ctx.formData,
        class: "button button--submit",
        disabled: !_ctx.formIsValid,
        onClick: _cache[13] || (_cache[13] = 
                    () =>
                        _ctx.amplitudeSendEvent(
                            _ctx.AmplitudeAnalyticsEvents.personalDetails
                                .PERSONAL_DETAILS_CONTINUE
                        )
                )
      }, null, 8, ["action", "button-value", "data", "disabled"])
    ], 42, _hoisted_4)
  ]))
}